window.addEventListener("pplrAppInitiated", function (e) {
  const forbiddenWords = new Set([
    "fuck",
    "shit",
    "bitch",
    "asshole",
    "cunt",
    "dick",
    "pussy",
    "twat",
    "wanker",
    "motherfucker",
    "nigger",
    "chink",
    "gook",
    "spic",
    "kike",
    "paki",
    "moor",
    "towelhead",
    "redskin",
    "cracker",
    "faggot",
    "homo",
    "dyke",
    "bitch",
    "slut",
    "whore",
    "tranny",
    "transvestite",
    "retard",
    "lame",
    "spastic",
    "cripple",
    "mental",
    "schizo",
    "dumb christian",
    "jew bastard",
    "muslim terrorist",
    "buddhist scum",
    "catholic whore",
    "kill",
    "die",
    "shoot",
    "rape",
    "murder",
    "slay",
    "bash",
    "choke",
    "beat",
    "hurt",
    "crackhead",
    "methhead",
    "heroin addict",
    "cocaine",
    "weed",
    "pills",
    "junkie",
    "drunk",
    "nazi",
    "kkk",
    "white supremacist",
    "racist",
    "fascist",
    "commie",
    "idiot",
    "moron",
    "stupid",
    "retard",
    "dumb",
    "loser",
    "lame",
    "fat",
    "ugly",
    "creep",
    "pussy",
    "ass",
    "bhole",
    "tits",
    "dickhead",
    "boob",
    "balls",
    "faggot",
    "bastard",
    "wanker",
    "skank",
    "slut",
    "whore",
    "asshole",
    "douchebag",
  ]);

  const excludedWords = new Set([
    "pass",
    "classic",
    "assignment",
    "assume",
    "assistance",
    "dickinson",
    "dickson",
    "pussycat",
  ]);

  const inputFields = document.getElementsByClassName("pplr_text");
  const addToCartButtons = document.getElementsByClassName("p_a_t_c"); // Select all Add to Cart buttons

  Array.from(inputFields).forEach((inputField) => {
    // Create a warning message element
    let warningMessage = document.createElement("div");
    warningMessage.style.color = "red";
    warningMessage.style.fontSize = "12px";
    warningMessage.style.display = "none";
    warningMessage.innerHTML = ""; // Placeholder for dynamic message
    inputField.parentNode.insertBefore(warningMessage, inputField.nextSibling);

    inputField.addEventListener("input", function () {
      let words = this.value.split(/\s+/);
      let detectedWords = words.filter((word) => {
        const lowerWord = word.toLowerCase();
        return forbiddenWords.has(lowerWord) && !excludedWords.has(lowerWord);
      });

      if (detectedWords.length > 0) {
        warningMessage.style.display = "block";
        warningMessage.innerHTML = `The following word(s) are not allowed: <strong>${detectedWords.join(
          ", "
        )}</strong>`;
        Array.from(addToCartButtons).forEach(
          (button) => (button.disabled = true)
        );
      } else {
        warningMessage.style.display = "none";
        warningMessage.innerHTML = "";
        Array.from(addToCartButtons).forEach(
          (button) => (button.disabled = false)
        );
      }
    });
  });

  jQuery(".ptc_button.pplr-btn").on("click", function () {
    setTimeout(() => {
      //console.log("OPENED");

      Array.from(inputFields).forEach((inputField) => {
        // Create a warning message element
        let warningMessage = document.createElement("div");
        warningMessage.style.color = "red";
        warningMessage.style.fontSize = "12px";
        warningMessage.style.display = "none";
        warningMessage.innerHTML = ""; // Placeholder for dynamic message
        inputField.parentNode.insertBefore(
          warningMessage,
          inputField.nextSibling
        );

        inputField.addEventListener("input", function () {
          let words = this.value.split(/\s+/);
          let detectedWords = words.filter((word) => {
            const lowerWord = word.toLowerCase();
            return (
              forbiddenWords.has(lowerWord) && !excludedWords.has(lowerWord)
            );
          });

          if (detectedWords.length > 0) {
            warningMessage.style.display = "block";
            warningMessage.innerHTML = `The following word(s) are not allowed: <strong>${detectedWords.join(
              ", "
            )}</strong>`;
            Array.from(addToCartButtons).forEach(
              (button) => (button.disabled = true)
            );
          } else {
            warningMessage.style.display = "none";
            warningMessage.innerHTML = "";
            Array.from(addToCartButtons).forEach(
              (button) => (button.disabled = false)
            );
          }
        });
      });
    }, 10);
  });
});
